
import { LeadFormData, Lead } from '@/types/lead';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/utils/toast';
import { validateLeadForm, sanitizeFormData } from '@/utils/formValidation';
import { resolveTrafficSource } from '@/utils/trafficSource';
import { getStoredReferralId } from '@/utils/referralTracking';

export const saveLead = async (formData: any, isEligible: boolean): Promise<Lead | null> => {
  try {
    // Validação final antes de salvar no Supabase
    const basicFormData = {
      name: formData.name || '',
      whatsapp: formData.whatsapp || '',
      cnpj: formData.cnpj || ''
    };
    
    console.log('🔍 Running final validation before saving to Supabase...');
    const validation = validateLeadForm(basicFormData);
    
    if (!validation.isValid) {
      console.error('❌ Final validation failed:', validation.errors);
      toast.error(`Erro de validação: ${validation.errors[0]}`);
      return null;
    }
    
    // Sanitizar dados uma última vez
    const sanitizedBasicData = sanitizeFormData(basicFormData);
    console.log('✅ Data passed final validation and sanitization');
    
    // Resolve traffic source
    const { sourceName, utmData } = resolveTrafficSource();
    console.log('🔍 Resolved traffic source:', sourceName, utmData);

    // Combinar dados sanitizados com dados extras
    const leadData = {
      name: sanitizedBasicData.name,
      whatsapp: sanitizedBasicData.whatsapp,
      email: formData.email || '',
      city: formData.city || '',
      state: formData.state || '',
      cnpj: sanitizedBasicData.cnpj,
      eligible: isEligible,
      tax_regime: formData.taxRegime || 'Não informado',
      emits_invoice: formData.emitsInvoice || false,
      monthly_revenue: formData.monthlyRevenue || 0,
      status: 'Novo lead' as const,
      submission_date: new Date().toISOString(),
      source_name: sourceName,
      utm_data: Object.keys(utmData).length > 0 ? utmData : null,
      page_url: typeof window !== 'undefined'
        ? `${window.location.pathname}${window.location.search}`
        : null,
      representative_id: getStoredReferralId(),
    };

    console.log('🚀 Attempting to save lead data to Supabase');

    // Insert without selecting to avoid RLS select restrictions; use minimal returning
      const { error } = await (supabase as any)
      .from('taxhealth_leads')
      .insert(leadData, { returning: 'minimal' });

    if (error) {
      console.error('❌ ERROR saving lead to Supabase database:', error.code);
      
      toast.error('Erro ao salvar dados. Por favor, tente novamente.');
      return null;
    }

    console.log('✅ Lead insert request sent successfully (no data returned due to RLS).');
    
    // Send notification email (async, non-blocking)
    console.log('📧 Sending email notification for new lead...');
    supabase.functions.invoke('notify-new-lead', {
      body: { lead: leadData }
    }).then((response) => {
      if (response.error) {
        console.error('📧 Error sending notification:', response.error);
      } else {
        console.log('📧 Notification sent successfully:', response.data);
      }
    }).catch((err) => {
      console.error('📧 Failed to send notification:', err);
    });
    
    // Construct a client-side temporary ID for UI continuity
    const tempLead: Lead = {
      ...leadData,
      id: 'temp-' + Date.now(),
      notes: 'Lead salvo no servidor (ID não retornado por RLS)',
      status: 'Novo lead',
      submission_date: leadData.submission_date,
      source: 'formulario',
      origin_table: 'taxhealth_leads',
    };
    toast.success('✅ Dados enviados com sucesso!');
    return tempLead;
  } catch (error) {
    console.error('❌ Error in saveLead function');
    toast.error('Erro ao salvar dados. Por favor, tente novamente.');
    return null;
  }
};
